// extracted by mini-css-extract-plugin
export default {"content":"ViewImage_content__mr4tr","canvas":"ViewImage_canvas__V36gC"};